module.exports = __webpack_public_path__ + "static/media/menopause-perimenopause-assessments-news.985ef23a.jpg";